// src/pages/DebtStudio/lib/scaleUtils.js
export function tenorToYears(tenor) {
  if (!tenor) return null;
  const t = tenor.toLowerCase();
  if (t.endsWith("mo")) return Number(t.replace("mo", "")) / 12;
  if (t.endsWith("m")) return Number(t.replace("m", "")) / 12;
  if (t.endsWith("y")) return Number(t.replace("y", ""));
  return null;
}

export function roundToBp(pct) {
  if (pct == null || !Number.isFinite(pct)) return null;
  // pct is already in percent form (5 = 5%)
  const dec = pct / 100; // convert to decimal for bp rounding
  return Math.round(dec * 10000) / 10000; // returns 0.05 for 5%
}

export function fmtPct2(pct) {
  if (pct == null || Number.isNaN(pct)) return "—";
  // pct is already in percent form
  return `${Number(pct).toFixed(2)}%`; // 5 → "5.00%"
}

export function formatCreatedStamp(dateObj = new Date()) {
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "America/Chicago",
    timeZoneName: "short",
  }).format(dateObj);
}

export function computeShiftDeltas(preset, magnitudeBps, pointsArray) {
  const currentPoints = pointsArray || [];
  const n = currentPoints.length;
  const deltas = {};
  if (!preset || preset === "none" || magnitudeBps == null || magnitudeBps === 0) {
    currentPoints.forEach((p) => (deltas[p.date] = 0));
    return deltas;
  }

  const m = Number(magnitudeBps) || 0;
  const lerp = (a, b, i, len) => { if (len <= 1) return a; return a + ((b - a) * i) / (len - 1); };

  if (preset === "parallel_up") { currentPoints.forEach((p) => (deltas[p.date] = Math.round(m))); return deltas; }
  if (preset === "parallel_down") { currentPoints.forEach((p) => (deltas[p.date] = Math.round(-m))); return deltas; }
  if (preset === "steepen") { const half = m / 2; currentPoints.forEach((p, i) => { deltas[p.date] = Math.round(lerp(-half, half, i, n)); }); return deltas; }
  if (preset === "flatten") { const half = m / 2; currentPoints.forEach((p, i) => { deltas[p.date] = Math.round(lerp(half, -half, i, n)); }); return deltas; }
  if (preset === "short_steepen") { const cut = Math.max(1, Math.floor(n / 3)); currentPoints.forEach((p, i) => { if (i <= cut - 1) { const taper = cut === 1 ? 1 : 1 - i / cut; deltas[p.date] = Math.round(m * taper); } else { deltas[p.date] = 0; } }); return deltas; }
  if (preset === "long_steepen") { const cut = Math.max(1, Math.floor(n / 3)); currentPoints.forEach((p, i) => { const idxFromEnd = n - 1 - i; if (idxFromEnd <= cut - 1) { const taper = cut === 1 ? 1 : 1 - idxFromEnd / cut; deltas[p.date] = Math.round(m * taper); } else { deltas[p.date] = 0; } }); return deltas; }

  currentPoints.forEach((p) => (deltas[p.date] = 0));
  return deltas;
}

export function sanitizeSheetName(name) {
  return (name || "Scale")
    .replace(/[\\/*?[\]]/g, "_")
    .substring(0, 31);
}
